import request from "graphql-request";
import { getToken } from "./helpers";
import { categoryDetailPageQuery } from "./Graphql/Queries/categoryPageQuery";

export async function fetchCategoryData (variables,url) {
    try{
    return getToken().then((token)=> {
        let headers = {
            "authorization": token
         }
         return request(url, categoryDetailPageQuery, variables, headers).then((res) => {
            return res
        })
     })
   }
     catch(err){
        console.error("GG", err);
     }
  }